import React from "react";
import { useHistory, useLocation, useParams } from "react-router-dom";

import { ServiceProviderTemplate } from "../../../template/service-provider/default-template";
import { ServiceProviderR } from "../routes";
import { connectPageService } from "../../../../application/domain/base/base-application-service";
import {
  ContextProps,
  ProcManagementPlacesListService,
} from "../../../../application/service/service-provider/proc-management/place-list";
import { FeatureEnabledOrgOnly } from "../../../organisms/proc-management/util";
import { Content } from "../../../organisms/proc-management/place-list";
import { parseQueryOfLocation } from "../../../../utils/url-utils";

const ProcManagementPlacesList: React.FC<ContextProps> = ({
  places,
  paging,
  fetchPlacesByOrgId,
}) => {
  const { orgId } = useParams<{ orgId: string }>();
  const location = useLocation();
  const page = parseQueryOfLocation(location).page;
  const pageNum =
    Number.isInteger(Number(page)) && Number(page) > 0
      ? Number(page)
      : undefined;
  const breadcrumbs = [
    { to: ServiceProviderR.Home.link({}), title: "テナント一覧" },
    {
      to: ServiceProviderR.ProcManagementProcsList.link({ orgId }),
      title: "手続きマスタ",
    },
    {
      to: ServiceProviderR.ProcManagementPlacesList.link({ orgId }),
      title: "場所マスタ",
    },
  ];

  const history = useHistory();
  const handleRowClick = React.useCallback(
    (props: { orgId: string; placeId: string }) => {
      history.push(ServiceProviderR.ProcManagementPlaceDetail.link(props));
    },
    [history],
  );
  const handlePageClick = React.useCallback(
    (props: { orgId: string; page: number }) => {
      history.push(ServiceProviderR.ProcManagementPlacesList.link(props));
    },
    [history],
  );

  React.useEffect(() => {
    fetchPlacesByOrgId(orgId, pageNum);
  }, [orgId, fetchPlacesByOrgId, pageNum]);

  return (
    <FeatureEnabledOrgOnly>
      <ServiceProviderTemplate breadcrumbs={breadcrumbs}>
        <Content
          places={places}
          paging={paging}
          orgId={orgId}
          onRowClick={handleRowClick}
          onPageClick={handlePageClick}
          isServiceProviderAccount
        />
      </ServiceProviderTemplate>
    </FeatureEnabledOrgOnly>
  );
};

export const ProcManagementPlacesListContainer = connectPageService(
  ProcManagementPlacesList,
  () => new ProcManagementPlacesListService(),
);
